import "core-js/modules/es.array.map.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Text from 'components/Text';
import { useFetchShareRecipientsCount } from 'actions/content';
import Hint from 'components/Hint';
var AutoShareInfo = function AutoShareInfo(_ref) {
  var playlistId = _ref.playlistId,
    autoShare = _ref.autoShare;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var type = autoShare.type,
    teams = autoShare.teams;
  var hasTeams = teams.length > 0;
  var _useFetchShareRecipie = useFetchShareRecipientsCount({
      contentId: playlistId,
      teamIds: type === 'teams' ? teams.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      }) : undefined,
      enabled: type === 'everyone' || type === 'teams' && hasTeams // No need to fetch user count if autoshare is disabled
    }),
    isLoading = _useFetchShareRecipie.isLoading,
    userCount = _useFetchShareRecipie.data;
  var hasEmailRecipients = userCount > 0;
  if (type === 'null' || type === 'teams' && !hasTeams) {
    return /*#__PURE__*/React.createElement(Hint, null, t('autoshare_disabled_hint'));
  }
  if (hasTeams && isLoading) {
    return /*#__PURE__*/React.createElement(Text, {
      dimmed: true
    }, t('autoshare_calculating_recipients_message'));
  }
  if (type === 'teams') {
    return /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "autoshare_with_team_hint",
      count: teams.length
    }), hasEmailRecipients && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "autoshare_with_user_hint",
      count: userCount
    })));
  }
  if (type === 'everyone' && hasEmailRecipients) {
    return /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "autoshare_with_everyone_in_future_and_now_hint",
      count: userCount
    }));
  }
  if (type === 'everyone' && !hasEmailRecipients) {
    return /*#__PURE__*/React.createElement(Hint, null, t('autoshare_with_everyone_in_future_hint'));
  }
  return null;
};
export default AutoShareInfo;